<div class="container-fluid bgcolor2">
    <div class="row col-sm-12 p-0 m-0 body">
      <div class="col-sm-12 scr">
  
        <!-- "max-height: 400px; overflow-y: scroll;
            style="width: 100%; height: 600px;" -->
  
        <img *ngIf="isImage" [src]="src" class="iiimg"
          style="width: 20rem; height: 18rem;  overflow-y: scroll; margin-top: 2rem; margin-bottom: 1rem;">
  
          <!-- <button *ngIf="!isImage" (click)="zoomIn()"><i class="fa fa-search-plus" aria-hidden="true"></i> </button> -->
          <pdf-viewer *ngIf="ispdf" [src]="src" [rotation]="0" [original-size]="false" [show-all]="true"
    [fit-to-page]="false" [zoom]="1" [zoom-scale]="'page-width'" [stick-to-page]="false" [render-text]="true"
    [external-link-target]="'blank'" [autoresize]="true" [show-borders]="false"
    class="pdfvi" ></pdf-viewer>
   
  
      </div>
  
      <div *ngIf="noDataaa"  class="Card">
        <img  style="width: 20rem; height: 20rem;  overflow-y: scroll; margin-top: 4rem; margin-bottom: -1rem;"
        src="../../assets/images/emp.png"
          >
      </div>
      <hr>
      <!-- <div class="row mt-1 mb-2 prpl"> -->
        <div class="col-sm-12 prpl">
          <button  mat-dialog-close class="btn dw btn-primary btn-icon-text floatright sz fr mt-1">Close</button>
         <button (click)="dowload();" *ngIf="showBtn"
            class="btn   sz fr btn-primary btn-icon-text floatright  mt-1">Download</button>
          
        </div>
      <!-- </div> -->
    </div>
  </div>